import axios from 'axios';
import {getCookie} from "../utils/getCookie";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    withCredentials: true,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        // 'Authorization': `token ${process.env.REACT_APP_API_KEY}:${process.env.REACT_APP_API_SECRET}`
    },
});


// Intercepteur pour ajouter le token CSRF dans les headers
api.interceptors.request.use((config) => {
    const csrfToken = getCookie('csrf_token');
    if (csrfToken) {
        config.headers['X-Frappe-CSRF-Token'] = csrfToken;
    }
    return config;
});

api.interceptors.response.use(
    response => response,
    error => {
        console.error("Erreur Axios :", error.response);
        return Promise.reject(error);
    }
);


export default api;
